













































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import CustomMap from '@/components/CustomMap.vue'
import {IRegisterFormData} from '@/store/modules/views/register/states'
@Component({
  components: { CustomMap },
})
export default class CreateUserDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private getList!: () => Promise<void>


  @Getter('components/prefixNames')
  private prefixNames: string[]

  private prefix: string = ''

  private firstname = ''
  private lastname = ''
  private phoneNumber = ''
  private cid = ''
  private address = ''
  private date = null
  private menu = false
  private activePicker = null
  private map = {
    lat: 0,
    lon: 0,
  }
  private location: IRegisterFormData['address'] = {address: ''}
  private loading = false
  private phoneRules = [
    (phone: string) => !!phone || 'กรุณากรอกหมายเลขโทรศัพท์',
    (phone: string) => this.validateInputFromType('phone', phone),
  ]
  private cidRules = [
    (cid: string) => !!cid || 'กรุณากรอกหมายเลขบัตรประจำตัวประชาชน',
    (cid: string) => this.validateInputFromType('cid', cid),
  ]

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', value)
  }

  get age() {
    const age = this.diffDate(this.date)
    const year = Math.floor(age)
    const month = Math.floor((age - year) * 12)
    return `อายุ ${year ? year + 'ปี ' : ''}${month}เดือน`
  }

  get getMap() {
    return this.map
  }

  get createUserDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'เพิ่ม',
          action: this.createUserAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('string', this.firstname, true),
          this.validateInputFromType('string', this.lastname, true),
          this.validateInputFromType('phone', this.phoneNumber, true),
          this.validateInputFromType('text', this.address, true),
          this.validateInputFromType('cid', this.cid, true),
        ],

        (item) => {
          return item !== true
        },
    )
  }

  private changeDateType() {
    this.menu = false
  }
  private async createUserAction() {
    const url = process.env.VUE_APP_API_URL + '/v1'
    if (this.map.lat === 0 && this.map.lon) {
      this.updateSnackbar({txt: 'กรุณาปักหมุดบนแผนที่', type: 'error'})
    }
    if (!this.invalidateInput) {
      const data = {
        prefix: this.prefix,
        firstname: this.firstname,
        lastname: this.lastname,
        phone: this.phoneNumber,
        birthdate: this.date,
        idCard: this.cid,
        map: this.map,
        address: {address: this.address, ...this.location},
      }
      this.loading = true
      try {
        await HttpRequestServiceWithToken.postByLevel(url, 'user', data, async () => {
          this.updateSnackbar({txt: 'บันทึกผู้ขอรับบริการสำเร็จ', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        })
      } catch (e) {
        this.loading = false
        return false
      }
    } else {
      this.loading = false
      this.updateSnackbar({txt: 'ข้อมูลไม่ครบถ้วนกรุณาตรวจสอบอีกครั้ง', type: 'error'})
      return false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  @Watch('menu')
  private birthdate(val) {
    if (val) {
      setTimeout(() => (this.activePicker = 'YEAR'))
    }
  }

  private async created() {
    this.phoneNumber = ''
    this.cid = ''
  }
}
